import React from 'react';

export default function Umbrella() {
	return (
		<span role="img" aria-label="umbrella">
			☂️
		</span>
	);
}
